import { ReportSource } from '@/features/Reports/interfaces';

import { MediaResolutionInput, ResolvedMedia } from '../types';
import {
  buildMediaResolutionInput,
  sourceNeedsMediaResolution,
} from '../ingestion/sourceMediaInputs';

type ResolveMediaApiResponse = {
  results: Array<{
    input: MediaResolutionInput;
    media: ResolvedMedia;
  }>;
};

export const resolveReportSourcesMediaViaApi = async (
  sources: Array<ReportSource>
): Promise<Array<ReportSource>> => {
  const pendingSources = sources
    .map((source, index) => ({
      source,
      index,
    }))
    .filter(({ source }) => sourceNeedsMediaResolution(source));

  if (!pendingSources.length) {
    return sources;
  }

  const inputs = pendingSources.map(({ source }) => buildMediaResolutionInput(source)!);

  const response = await fetch('/api/media/resolve', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ inputs }),
  });

  if (!response.ok) {
    return sources;
  }

  const payload = (await response.json()) as ResolveMediaApiResponse;
  const nextSources = [...sources];

  pendingSources.forEach(({ index }, resultIndex) => {
    nextSources[index] = {
      ...nextSources[index],
      resolvedMedia: payload.results[resultIndex]?.media,
    };
  });

  return nextSources;
};
